import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/garcom/mesas')({
  beforeLoad: () => {
    throw redirect({ to: '/mesas' })
  },
})
